import  { React, useEffect } from 'react'
import { Link } from 'react-router-dom';
import '../assets/navbar.css'
import '../assets/home/modal.css'
import BarreNav from './BarreNav';


function Navbar() {
    
    useEffect(() => {
        document.addEventListener("scroll", () => {
          let header = document.querySelector('#menu');
          if (window.scrollY > 57) {
            header?.classList.add('scrolled');
          } else {
            header?.classList.remove('scrolled');
          }
        });
    },[]);

  return (
    <div className='menu sticky-top' id='menu'>
        <div className="container-fluid text-white text-center" id='navbar-haut'>
            <span> A partir de 50€ d'achat, 2gr de fleurs de CBD offerts ET à partir de 80€ d'achat, 2gr de fleurs de HHC offerts !</span>
        </div>
        <nav className="navbar bg-body-tertiary" id='navbar-bas'>
            <div className="container">        
                <Link className="navbar-brand ms-md-auto ms-lg-auto" to={'/'}>
                    <img src={window.location.origin +"/images/logo.svg"} className='logoapp' alt=""  />
                </Link>
                <form className="d-flex ps-lg-5 ms-lg-5 ps-md-5 ms-md-5" role="search">
                    <div className="input-group" id="form-search">
                        <input type="email" placeholder='Rechercher' data-bs-toggle="modal" data-bs-target="#exactModal" />
                        <button type='button' data-bs-toggle="modal" data-bs-target="#exactModal"><img src={window.location.origin +"/images/search.svg"} alt="" /></button>
                    </div>
                    <div className="icones mt-3 d-flex">
                        <Link to={window.location.origin+"/panier"} id='panier'  className='ps-3 text-white'>
                            <img src={window.location.origin +"/images/panier.svg"} alt="" />
                        </Link>
                        <Link to={window.location.origin+"/mon-compte"} id='compte' className='ps-3 text-white'>
                            <img src={window.location.origin +"/images/user.svg"} alt="" />
                        </Link>
                </div>
                </form>
                
            </div>
            
        </nav>
        <nav className="navbar navbar-expand-lg navbar-dark" id='barnav'>
            <div className="container-fluid">
                <BarreNav />
            </div>
        </nav>
         
    </div>
  )
}

export default Navbar